import React, { useState, VFC } from 'react'
import styled, { css } from 'styled-components'

import Rainbowwheel from '@Assets/SVG/Rainbowwheel'
import { Button } from '@Components/Button'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

export const PersonalisationButtonRoot = styled(Button)(({ theme }) => css`
  height: 48px;
  border-color: ${theme.colors.greyDark};
  border-radius: 0;
  border-left-width: 0;
  border-right-width: 0;

  ${up('mobileStyleThreshold')} {
    border-radius: ${theme.borderRadius};
    border-left-width: 1px;
    border-right-width: 1px;
  }

  span {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    color: ${theme.colors.greyDark};
    font-size: 0.875rem;

    ${up('tablet')} {
      font-size: inherit;
    }

    svg {
      width: 17px;
      height: 17px;
    }

    img {
      width: 16px;
      height: 16px;
    }

    svg,
    img {
      margin-right: 10px;
    }
  }
`)

interface Props {
  callback: () => void
}

export const MakeItPersonalButton: VFC<Props> = ({ callback }) => {
  const { t } = useTranslation()
  const [imageError, setImageError] = useState(false)

  return (
    <PersonalisationButtonRoot onClick={callback} variant="outlined">
      {!imageError
        ? (
          <img
            alt="rainbow wheel"
            onError={() => setImageError(true)}
            src="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltf65883e3eea27b85/62d7958e77f8920f575be5f4/rainbowwheel.png?width=17&height=17"
          />
        )
        : <Rainbowwheel />}
      {t('products:MAKE_IT_PERSONAL')}
    </PersonalisationButtonRoot>
  )
}
